'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:disqusThread');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * DisqusThread is a Web Component responsible for loading a Disqus Thread.
     * For CLS reasons, we switched from lazy-loading upon visible to loading
     * as soon as the user starts scrolling or if the user lands anywhere other
     * than the top of the page.
     *
     * @example
     *     <phoenix-disqus-thread
     *         shortname="test"
     *         thread-identifier="testId"
     *         thread-title="test"
     *         thread-url="https://test"
     *     ></phoenix-disqus-thread>
     */
    class DisqusThread extends pageClass.PhoenixElement {
        connectedCallback() {
            this.disqusScriptAdded = false;
            this.shortname = this.getAttr('shortname', { required: true });
            this.threadTitle = this.getAttr('thread-title', { required: true });
            this.threadIdentifier = this.getAttr('thread-identifier', { required: true });
            this.threadUrl = this.getAttr('thread-url', { required: true });

            if (typeof window.DISQUS !== 'undefined') {
                throw new Error(
                    'Disqus already loaded, this web component supports only one instance per page.'
                );
            }

            pageClass.util.userHasPremium().then((userHasPremium) => {
                this.disableDiscoveryAds = userHasPremium;
                this._addListenerOrScript();
            });
        }

        /**
         * DOM manipulations to load the Disqus thread.
         */
        addDisqusScript() {
            // inject the div
            const div = document.createElement('div');
            div.id = 'disqus_thread';
            this.appendChild(div);

            // set global parameters
            window.disqus_shortname = this.shortname;
            window.disqus_identifier = this.threadIdentifier;
            window.disqus_url = this.threadUrl;
            window.disqus_title = this.threadTitle;
            const self = this;
            this.disqusScriptAdded = true;
            // insert the script tag
            pageClass.util.addScriptResourceOnce('https://' + this.shortname + '.disqus.com/embed.js', {
                id: 'disqus-thread',
            });
        }

        _checkScrollPosition() {
            if (this.disqusScriptAdded) {
                this._removeListener();
            } else {
                this.addDisqusScript();
            }
        }

        _addListenerOrScript() {
            if (window.scrollY > 0) {
                this.addDisqusScript();
            } else {
                this.scrollListener = pageClass.util.debounce(this._checkScrollPosition.bind(this), 50);
                window.addEventListener('scroll', this.scrollListener);
            }
        }

        _removeListener() {
            if (this.scrollListener) {
                window.removeEventListener('scroll', this.scrollListener);
            }
        }

        disconnectedCallback() {
            this._removeListener();
        }
    }
    window.customElements.define('phoenix-disqus-thread', DisqusThread);
    measure.end();
});
